export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8550.60afd351.jpg";